import { mergeWith } from 'lodash';

const baseFontSize = 24;

export function getFontSize(size) {
  return size * baseFontSize;
}

const color = [
  '#00BFFF', // DeepSkyBlue
  '#32CD32', // LimeGreen
  '#FFD700', // Gold
  '#FF8C00', // DarkOrange
  '#8A2BE2', // BlueViolet - excluded as it's purple
  '#00FA9A', // MediumSpringGreen
  '#FF1493', // DeepPink - excluded as it's red/pink
  '#00CED1', // DarkTurquoise
  '#FF4500', // OrangeRed - excluded as it's red
  '#20B2AA', // LightSeaGreen
  '#FF6347', // Tomato - excluded as it's red
  '#7CFC00', // LawnGreen
  '#4169E1', // RoyalBlue
  '#FF69B4', // HotPink - excluded as it's pink/red
  '#2E8B57', // SeaGreen
  '#FFE4B5', // Moccasin
  '#8B4513', // SaddleBrown
  '#556B2F', // DarkOliveGreen
  '#483D8B' // DarkSlateBlue - excluded as it's purple
];

export function makePieOptions() {
  const options = {
    color,
    title: {
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : ({d}%)'
    },
    legend: {
      show: false,
      type: 'scroll',
      orient: 'vertical',
      right: 10,
      top: 20,
      bottom: 20,
      textStyle: {
        fontSize: getFontSize(0.9)
      }
      // data: data.legendData
    },
    series: [
      {
        name: '名称',
        type: 'pie',
        radius: '55%',
        center: ['50%', '50%'],
        label: {
          fontSize: getFontSize(1)
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ],
    dataset: {
      source: []
    }
  };

  return {
    options,
    setData: (data, opts) => {
      mergeWith(options, opts);

      options.dataset.source.splice(0, Infinity, ...data);
    }
  };
}

export function makeLineOptions() {
  const options = {
    color,
    title: {
      left: 'center'
    },
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '8%',
      top: '17%',
      right: '6%',
      bottom: '5%',
      containLabel: true
    },
    legend: {
      show: true,
      type: 'scroll',
      right: 10,
      top: 3,
      bottom: 15,
      textStyle: {
        color: '#fff',
        fontSize: getFontSize(0.9)
      }
    },
    xAxis: {
      type: 'category',
      splitLine: {
        show: false,
        lineStyle: {
          color: '#283763'
        }
      },
      axisLabel: {
        fontSize: getFontSize(0.95)
      },
      axisLine: {
        lineStyle: {
          color: '#04d7ff'
        }
      }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisLabel: {
        fontSize: getFontSize(0.95)
      },
      axisLine: {
        lineStyle: {
          color: '#04d7ff'
        }
      },
      max: v => {
        return v.max + 1;
      }
    },
    series: [],
    dataset: {
      dimensions: [],
      source: []
    }
  };

  return {
    options,
    setData: (data, opts) => {
      mergeWith(options, opts);

      options.dataset.source.splice(0, Infinity, ...data);
    }
  };
}

export function makeBarOptions() {
  const options = {
    color: ['#32cd32', 'orange'],
    title: {
      left: 'center'
    },
    grid: {
      left: '7%',
      top: '10%',
      right: '6%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: true,
      type: 'scroll',
      right: 10,
      top: 2,
      bottom: 20,
      textStyle: {
        color: '#fff',
        fontSize: getFontSize(0.9)
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      splitLine: {
        show: false,
        lineStyle: {
          color: '#283763'
        }
      },
      axisLabel: {
        fontSize: getFontSize(0.95),
        rotate: 35
      },
      axisLine: {
        lineStyle: {
          color: '#04d7ff'
        }
      }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisLabel: {
        fontSize: getFontSize(0.9)
      },
      axisLine: {
        lineStyle: {
          color: '#04d7ff'
        }
      }
    },
    series: [],
    dataset: {
      dimensions: [],
      source: []
    }
  };

  return {
    options,
    setData: (data, opts) => {
      mergeWith(options, opts);

      options.dataset.source.splice(0, Infinity, ...data);
    }
  };
}
